import {ContentOption, ContentProps} from "./components/Content";
import {renderNumericTextBox, renderRadioGroupProps, renderSingleSelect} from "./renderer";

export const DEFAULT_DWELL_MINUTES = 5;
export const MAX_DWELL_MINUTES = 60;
export const MIN_DWELL_MINUTES = 1;
export const DEFAULT_NUMBER_OF_UPCOMING_STOPS = 9;
export const MIN_NUMBER_OF_UPCOMING_STOPS = 1;
export const MAX_NUMBER_OF_UPCOMING_STOPS = 9;

export const GPS_FREQUENCY_MINUTES_OPTIONS: ContentOption[] = [15, 5, 3, 1].map((value) => ({
  group: "gpsFrequency",
  label: value.toString(),
  value: value
}));
export const DEFAULT_GPS_FREQUENCY_MINUTES = 15;

// Suggested assignment daily cap (DP-3194).
export const DEFAULT_SUGGESTED_ASSIGNMENTS_PER_DAY = 5;
export const MIN_SUGGESTED_ASSIGNMENTS_PER_DAY = 0;

// Assignment Submitted Notification (DP-3231): unset means Yes (the toast shows).
export const ASSIGNMENT_SUBMITTED_NOTIFICATION_DEFAULT = true;

// Itinerary (route planning) weekly limit (DP-3062).
export enum RoutePlanLimitMode {
  Unlimited = "Unlimited",
  Limited = "Limited"
}
// Default shown for a tenant with no configured limit: Limited, 2 plans/week.
export const DEFAULT_ROUTE_PLANNING_LIMIT = 2;

export const ContentOptionProps: ContentProps = {
  contentTitle: "",
  contentOptions: [],
  contentInformation: "",
  contentUnit: "",
  selectedOption: "",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  handleChangeOption: () => {},
  renderPropComponents: renderRadioGroupProps,
  isDisabled: () => false
};

export const ContentNumericProp: ContentProps = {
  contentTitle: "",
  contentOptions: [],
  contentInformation: "",
  contentUnit: "",
  selectedOption: "",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  handleChangeOption: () => {},
  renderPropComponents: renderNumericTextBox,
  isDisabled: () => false
};

export const ContentSingleSelectProp: ContentProps = {
  contentTitle: "",
  contentOptions: [],
  contentInformation: "",
  contentUnit: "",
  selectedOption: "",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  handleChangeOption: () => {},
  renderPropComponents: renderSingleSelect,
  isDisabled: () => false,
  tooltipContent: () => ""
};
